export default __webpack_public_path__ + "static/media/ikedc.fe93bdac.jpg";